import { create } from "zustand";
import { ProfileData, UserWorkingStatus } from "@/interface/types";

interface ProfileState {
  profileData: Partial<ProfileData>;
  setProfile: (userData: ProfileData) => void;
  setWorkingStatus: (status: UserWorkingStatus) => void;
  clearProfile: () => void;
}

const useProfileStore = create<ProfileState>((set) => ({
  profileData: {},
  setProfile: (profileData) => {
    set(() => ({ profileData: profileData }));
  },
  setWorkingStatus: (status) => {
    set((state) => ({
      profileData: {
        ...state.profileData,
        working_status: status,
        working_status_updated_at: new Date().toISOString(),
      },
    }));
  },
  clearProfile: () => {
    set(() => ({ profileData: {} }));
  },
}));

export default useProfileStore;
